/* MAGIJOUETS – scroll reveal and moving sparkles (snippets/mj-motion).
   v17 (2026-10-10, speed): moved from the inline <script> of snippets/mj-motion.liquid, which now loads this file with defer at
   the same place. The browser and Shopify's CDN keep it in cache, so it is no longer downloaded again inside every page.
   Asset files cannot hold Liquid. */
(function () {
  if (window.mjReveal) return;
  var root = document.documentElement;
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = !!(window.Shopify && window.Shopify.designMode);
  var hasIO = 'IntersectionObserver' in window;
  var SEL = '[data-mj-reveal]:not(.is-in)';
  var pending = [], alive = false;
  function show(el) { el.classList.add('is-in'); if (io) io.unobserve(el); }
  // on screen or already scrolled past (top above the bottom 6 % of the screen) and laid out
  function seen(el) {
    var r = el.getBoundingClientRect();
    if (!r.width && !r.height) return false;
    return r.top < (window.innerHeight || 800) * 0.94 && r.bottom > -99999;
  }
  var io = (!still && !editor && hasIO) ? new IntersectionObserver(function (entries) {
    alive = true;
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      // a tall element counts once a good part of the screen shows it
      if (e.intersectionRatio >= 0.12 || e.intersectionRect.height >= (window.innerHeight || 800) * 0.25) show(e.target);
    });
  }, { threshold: [0, 0.12, 0.25], rootMargin: '0px 0px -6% 0px' }) : null;

  function scan(scope) {
    var list = (scope && scope.querySelectorAll ? scope : document).querySelectorAll(SEL);
    if (scope && scope.matches && scope.matches(SEL)) list = [scope].concat([].slice.call(list));
    [].forEach.call(list, function (el) {
      if (!io) { show(el); return; }
      if (el.__mjObs) return;
      el.__mjObs = true;
      if (seen(el)) show(el); else { io.observe(el); pending.push(el); }
    });
  }

  // scrolled past or on screen when the scrolling stops: shown even if the observer missed it
  var deepest = 0, ticking = false, settle = null;
  function sweep(onScreen) {
    var y = window.pageYOffset || root.scrollTop || 0, vh = window.innerHeight || 800, vw = window.innerWidth || 400;
    if (y > deepest) deepest = y;
    pending = pending.filter(function (el) {
      if (el.classList.contains('is-in') || !el.isConnected) return false;
      var r = el.getBoundingClientRect();
      if (!r.width && !r.height) return true;
      if (r.bottom + y <= deepest || (onScreen && r.top < vh * 0.94 && r.bottom > 0 && r.left < vw && r.right > 0)) { show(el); return false; }
      return true;
    });
  }
  function onScroll() {
    if (!pending.length) return;
    if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; sweep(false); }); }
    clearTimeout(settle); settle = setTimeout(function () { sweep(true); }, 140);
  }
  window.mjReveal = function (scope) { scan(scope || document); };
  root.classList.add('mj-mo');
  if (io) window.addEventListener('scroll', onScroll, { passive: true });

  function start() {
    scan(document);
    if ('MutationObserver' in window && document.body) {
      var queued = false;
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) {
            if (!queued) { queued = true; requestAnimationFrame(function () { queued = false; scan(document); }); }
            return;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    // safety: whatever is on screen or above it after 3 s is shown, even if the observer missed it;
    // everything if the observer never answered (broken browser)
    setTimeout(function () {
      var dead = io && pending.length && !alive;
      [].forEach.call(document.querySelectorAll(SEL), function (el) { if (!io || dead || seen(el)) show(el); });
    }, 3000);
  }
  // v17: as a deferred file this runs once the page is parsed but before DOMContentLoaded: it still waits for that event, as the inline script did
  if ((document.readyState === 'loading' || (document.readyState === 'interactive' && !(window.performance && performance.timing && performance.timing.domContentLoadedEventStart)))) document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target || document); });
  // coming back with the browser's back button: the page is restored as it was, show everything on screen
  window.addEventListener('pageshow', function (e) { if (e.persisted) scan(document); });
})();

/* The sparkles behind every page move while the page scrolls and stop when it stops (owner, 2026-10-07): they go
   on their own layer, one 420 px tile taller than the screen, which slides up at 30 % of the scroll (and back down
   when scrolling up), so they seem farther away than the page. Not under reduced motion (they stay still, as
   before); without this script the still sparkles of body::before show (snippets/mj-style). */
(function () {
  if (window.__mjSky || !document.body) return; window.__mjSky = true;
  var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (rm && rm.matches) return;
  var H = 420, K = 0.3, raf = 0, last = -1;
  var sky = document.createElement('div'), layer = document.createElement('i');
  sky.className = 'mj-sky'; sky.setAttribute('aria-hidden', 'true'); sky.appendChild(layer);
  document.body.insertBefore(sky, document.body.firstChild);
  document.documentElement.classList.add('mj-sky-on');
  function draw() {
    raf = 0;
    var y = Math.max(0, window.scrollY || window.pageYOffset || 0), ty = Math.round((H - (y * K) % H) * 10) / 10;
    if (ty === last) return; last = ty;
    layer.style.transform = 'translate3d(0,' + ty + 'px,0)';
  }
  draw();
  window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(draw); }, { passive: true });
  window.addEventListener('pageshow', draw);
})();
